import { bl_dgmkt_project_hdr_RowClass } from '../../../dbschema/bl_dgmkt_project_hdr.model';
import { bl_dgmkt_project_ext_RowClass } from '../../../dbschema/bl_dgmkt_project_ext.model';
import { BaseContainerModel } from '../../base-container.model';
import { bl_dgmkt_project_line_RowClass } from '../../../dbschema/bl_dgmkt_project_line.model';
import { bl_dgmkt_project_event_RowClass } from '../../../dbschema/bl_dgmkt_project_event.model';

export class DgMktProjectContainerModel extends BaseContainerModel {
  bl_dgmkt_project_hdr: bl_dgmkt_project_hdr_RowClass = new bl_dgmkt_project_hdr_RowClass();
  bl_dgmkt_project_exts: bl_dgmkt_project_ext_RowClass[] = [];
  bl_dgmkt_project_lines: bl_dgmkt_project_line_RowClass[] = [];
  // bl_dgmkt_project_event: bl_dgmkt_project_event_RowClass[] = [];
}
